import { BrowserRouter } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import { AuthProvider } from "./context/AuthContext";
import { FilterProvider } from "./context/FilterContext";
import { LoaderProvider } from "./context/LoaderContext";
import AppRoutes from "./routes/AppRoutes";

export default function App() {
    return (
        <PrimeReactProvider>
            <LoaderProvider>
                <AuthProvider>
                    <FilterProvider>
                        <BrowserRouter>
                            <AppRoutes />
                        </BrowserRouter>
                    </FilterProvider>
                </AuthProvider>
            </LoaderProvider>
        </PrimeReactProvider>
    );
}